import { render, staticRenderFns } from "./AliasTable.vue?vue&type=template&id=7ef8ba88&scoped=true&"
import script from "./AliasTable.vue?vue&type=script&lang=js&"
export * from "./AliasTable.vue?vue&type=script&lang=js&"
import style0 from "./AliasTable.vue?vue&type=style&index=0&id=7ef8ba88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef8ba88",
  null
  
)

export default component.exports